<template>

<div class="progress-steps">
    <ul class="list-equal">
        <li v-for="n in steps" class="progress-steps__step" :class="{'progress-steps__step--active': step >= stagechanges[n-1]}"><span></span></li>
    </ul>
</div>

</template>

<script>
export default {
    props: {
        steps: Number,
        title: String,
        step: Number,
        stagechanges: Array
    },
    data: function() {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ProgressSteps.vue